import {h, Fragment} from "preact"
import { useEffect } from "preact/hooks"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import QuickAdd from "./QuickAdd"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    return (
        <>
            {/* {products?.hits?.map((hit, index) => {
                if(hit?.skus?.length > 1){
                    return <QuickAdd product={hit} key={`quickadd-${hit.productId || index}`} />
                } else {
                    return null;
                }
            })} */}
            <ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop" 
            style={loading ? "opacity: 0.3;" : ""}
            >
                {products.hits.map((hit, index) => {
                    return <Product product={hit} key={hit.productId || index} />
                })}
            </ul>
        </>
    )
}
